import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const getDefaultState = () => {
    return {
        token: '',
        userSlug: ''
    };
};

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: getDefaultState(),
  getters: {
    isLoggedIn: state => {
      return state.token;
    },
    getUserToken: state => {
      return state.token;
    },
    getUserUserSlug: state => {
      return state.userSlug;
    },
    signUpAllowed: () => {
      return process.env.VUE_APP_SIGNUP_ALLOWED === 'true';
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    RESET: state => {
      Object.assign(state, getDefaultState());
    },
    SET_USER_SLUG: (state, userSlug) => {
      state.userSlug = userSlug;
    }
  },
  actions: {
    login: ({ commit, dispatch }, { token, userSlug }) => {
      commit('SET_TOKEN', token);
      commit('SET_USER_SLUG', userSlug);
      // set auth header
      //Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    logout: ({ commit }) => {
      commit('RESET', '');
    }
  }
});